import * as React from "react";
import { Text, Image, StyleSheet, View, TouchableOpacity } from "react-native";
import { useNavigation } from "@react-navigation/native";

export default function MainMenu() {
  const navigation = useNavigation();
  const BlueBarCodeIcon = require("../assets/images/blue_BC_icon_lg.png");

  return (
    <TouchableOpacity
      style={styles.iconContainer}
      onPress={() => navigation.navigate("BarCode")}
    >
      <View style={styles.rightIconContainer}>
        <Image
          style={styles.BlueBarCodeIcon}
          source={BlueBarCodeIcon}
          resizeMode="cover"
        />
      </View>
    </TouchableOpacity>
  );
}
const styles = StyleSheet.create({
  iconContainer: {
    paddingRight: 15,
    top: -6,
  },

  BlueBarCodeIcon: {
    height: 31,
    width: 43,
  },
});
